import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import { Dialog, LinkButton } from 'rc-easyui';

import MultipleFindView_create from './MultipleFindView_create';

import { setStatusValue } from '../../actions/Project/ProjectListAction';

import { setIsShowFindAllViewList } from '../../actions/transOperationActions';

import {
  setIsShowFindAllViewInput,
  setIsShowFindAllViewReplace,
} from '../../actions/transOperation_find_Actions';
import {
  showHideMultipleView,
  getMultipleFindData,
  removeMultipleFindItem,
  duplicateMultipleFindItem,
  setCreateMutileData,
  updateMultipleFindData,
} from '../../actions/find/mutileFindAction';

class MultipleFindView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tmpMultipleFindData: [], //臨時內容

      tmpItemsData: [], //想要新增的物件

      value: 11,
      errors: {},
      isShowCreate: false,
      isShowFindForm: false,
      isShowSavaChangeForm: false, //儲存視窗

      currEditIndex: 0, //想要編輯的item index
      currEditTitle: '', //當前標題

      isOpenCreateMultipleView: false,

      //新增輸入
      inputFind: '',
      inputPlace: '',
      inputTitle: '',
    };
    this.closefindAllView_input = this.closefindAllView_input.bind(this);
    this.closefindAllView_list = this.closefindAllView_list.bind(this);
    this.closefindAllView_replace = this.closefindAllView_replace.bind(this);
    this.setShowCreate = this.setShowCreate.bind(this);
    this.closeDialog = this.closeDialog.bind(this);

    //開啟新增視窗
    // this.closeCreateView = this.closeCreateView.bind(this);
  }

  //開啟新增視窗
  closeCreateView() {
    console.log(`closeCreateView`);
  }

  async closeDialog() {
    this.props.showHideMultipleView(false);
  }

  async componentDidMount() {
    await this.setState({ value: this.props.project.statusValue });

    //確認資料
    let currMultipleFindData = this.props.getMultipleFindData();
    // console.log(`currMultipleFindData ${currMultipleFindData}`);
    await this.setState({ tmpMultipleFindData: currMultipleFindData });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.errors) {
      this.setState({ errors: nextProps.errors });
    }
    if (nextProps.findOperation) {
      const isShowMutileFindDialog =
        nextProps.findOperation.isShowMutileFindDialog;
      if (isShowMutileFindDialog === true) {
        this.dlg.open();
      }

      //顯示資料
      this.setState({
        multipleFindData: nextProps.findOperation.multipleFindData,
      });

      this.setState({
        isOpenCreateMultipleView:
          nextProps.findOperation.isOpenCreateMultipleView,
      });
    }
  }

  async setShowCreate(result) {
    await this.setState({ isShowCreate: result });
  }

  async setShowFindForm(result) {
    await this.setState({ isShowFindForm: result });
  }

  async setSaveChangeForm(result) {
    await this.setState({ isShowSavaChangeForm: result });
  }

  async closefindAllView_input() {
    this.props.setIsShowFindAllViewInput(false);
  }

  async closefindAllView_list() {
    this.props.setIsShowFindAllViewList(false);
  }
  async closefindAllView_replace() {
    this.props.setIsShowFindAllViewReplace(false);
  }

  render() {
    let {
      isShowCreate,
      isShowFindForm,
      isShowSavaChangeForm,
      currEditIndex,
      tmpMultipleFindData,
      isOpenCreateMultipleView,
      inputTitle,
    } = this.state;
    let { multipleFindData } = this.props.findOperation;

    let mainContent;

    //主要的物件
    let mainitemsArray = null;
    if (multipleFindData.length !== 0) {
      mainitemsArray = multipleFindData.map((request, index) => {
        const { title, items } = request;

        return (
          <tr key={index}>
            <td>
              <button
                className='text-primary'
                onClick={() => {
                  this.setShowCreate(true);

                  //按下去的物件index
                  this.setState({ currEditIndex: index });
                  //選擇到的標題
                  this.setState({ inputTitle: title });
                }}
              >
                {title}
              </button>
            </td>

            <td>{items.length}</td>
            <td>
              <button
                type='button'
                className='btn btn-primary'
                onClick={() => {
                  this.props.removeMultipleFindItem(multipleFindData, index);
                }}
              >
                Remove
              </button>
            </td>
            <td>
              <button
                type='button'
                className='btn btn-primary'
                onClick={() => {
                  this.props.duplicateMultipleFindItem(multipleFindData, index);
                }}
              >
                Duplicate
              </button>
            </td>
          </tr>
        );
      });
    }

    //物件群
    let itemsArray = null;
    if (isShowCreate === true && tmpMultipleFindData.length !== 0) {
      let items = tmpMultipleFindData[currEditIndex].items;
      itemsArray = items.map((request, index) => {
        const { findText, replaceText } = request;

        return (
          <tr key={index}>
            <td>
              <button className='text-primary' onClick={() => {}}>
                {findText}
              </button>
            </td>
            <td>{replaceText}</td>
            <td>
              <button
                type='button'
                className='btn btn-primary'
                onClick={() => {
                  //刪除掉直接更新
                  let newtmpMultipleFindData = tmpMultipleFindData;

                  let editTarget = newtmpMultipleFindData[currEditIndex];

                  editTarget.items.splice(index, 1);

                  this.setState({
                    tmpMultipleFindData: newtmpMultipleFindData,
                  });

                  this.props.updateMultipleFindData(newtmpMultipleFindData);
                }}
              >
                Remove
              </button>
            </td>
          </tr>
        );
      });
    }

    // 產生一個全新的物件群
    if (isOpenCreateMultipleView === true) {
      mainContent = (
        <Dialog
          title='Multiple Find Create'
          style={{ width: '700px', height: '600px' }}
          modal
          ref={(ref) => (this.dlg = ref)}
        >
          <MultipleFindView_create />
        </Dialog>
      );
    } else {
      if (isShowCreate === false) {
        mainContent = (
          <Dialog
            title='Multiple Find'
            style={{ width: '700px', height: '600px' }}
            modal
            ref={(ref) => (this.dlg = ref)}
          >
            <p style={{ margin: '50px 0', fontSize: '16px' }}>
              <table className='table'>
                <thead>
                  <tr>
                    <th scope='col'>Name</th>
                    <th scope='col'>Items</th>
                    <th scope='col'> </th>
                    <th scope='col'> </th>
                  </tr>
                </thead>
                <tbody>{mainitemsArray}</tbody>
              </table>
            </p>
            <LinkButton
              style={{ width: 80 }}
              onClick={() => {
                this.setShowCreate(true);

                //是新增
                this.props.setCreateMutileData(true);
              }}
            >
              Create
            </LinkButton>

            <hr />
            <div className='my-3 float-right'>
              <LinkButton
                style={{ width: 80 }}
                onClick={() => this.closeDialog(true)}
              >
                Close
              </LinkButton>
            </div>
          </Dialog>
        );
      } else {
        mainContent = (
          <Dialog
            title='Multiple Find'
            style={{ width: '700px' }}
            modal
            ref={(ref) => (this.dlg = ref)}
          >
            <table className='table'>
              <thead>
                <tr>
                  <th scope='col'>Find</th>
                  <th scope='col'>Replace with</th>
                </tr>
              </thead>
              <tbody>{itemsArray}</tbody>
            </table>

            <div style={{ marginBottom: '20px' }}>
              <LinkButton
                onClick={() => {
                  this.setShowFindForm(true);
                  this.setSaveChangeForm(false);
                }}
              >
                Add item
              </LinkButton>
              <LinkButton
                onClick={() => {
                  this.setShowFindForm(false);
                  this.setSaveChangeForm(true);

                  //是新增
                  this.setState({ isCreateOne: true });
                }}
              >
                Save Changes
              </LinkButton>
            </div>

            {/* 新增物件視窗 */}
            {isShowFindForm && (
              <form className='p-3' style={{ backgroundColor: '#eeeeee' }}>
                <div className='form-group'>
                  <label htmlFor='inputAddress'>Find:</label>
                  <input
                    type='text'
                    className='form-control'
                    id='inputAddress'
                    placeholder=' '
                    value={this.state.inputFind}
                    onChange={(event) =>
                      this.setState({ inputFind: event.target.value })
                    }
                  />
                </div>
                <div className='form-group'>
                  <label htmlFor='inputAddress2'>Replace with:</label>
                  <input
                    type='text'
                    className='form-control'
                    id='inputAddress2'
                    placeholder=' '
                    value={this.state.inputPlace}
                    onChange={(event) =>
                      this.setState({ inputPlace: event.target.value })
                    }
                  />
                </div>
                <div style={{ marginBottom: '20px' }}>
                  <LinkButton
                    onClick={() => {
                      if (
                        this.state.inputFind !== '' &&
                        this.state.inputPlace !== ''
                      ) {
                        // 更新　tmpMultipleFindData
                        let newtmpMultipleFindData = tmpMultipleFindData;

                        let editTarget = newtmpMultipleFindData[currEditIndex];

                        editTarget.items.push({
                          findText: this.state.inputFind,
                          replaceText: this.state.inputPlace,
                        });

                        this.setState({
                          tmpMultipleFindData: newtmpMultipleFindData,
                        });
                        this.setState({ inputFind: '' });
                        this.setState({ inputPlace: '' });

                        this.props.updateMultipleFindData(
                          newtmpMultipleFindData
                        );
                      }
                    }}
                  >
                    Add item
                  </LinkButton>
                  <LinkButton onClick={() => this.setShowFindForm(false)}>
                    Cancel
                  </LinkButton>
                </div>
              </form>
            )}

            {/* 儲存視窗 */}
            {isShowSavaChangeForm && (
              <form className='p-3' style={{ backgroundColor: '#EEEEEE' }}>
                <div className='form-group'>
                  <label htmlFor='inputAddress'>Name:</label>
                  <input
                    type='text'
                    className='form-control'
                    id='inputAddress'
                    placeholder=' '
                    value={this.state.inputTitle}
                    onChange={(event) =>
                      this.setState({ inputTitle: event.target.value })
                    }
                  />
                </div>
                <div style={{ marginBottom: '20px' }}>
                  <LinkButton
                    onClick={() => {
                      //新資料
                      let newtmpMultipleFindData = tmpMultipleFindData;

                      let targetFindData =
                        newtmpMultipleFindData[currEditIndex];
                      //改名稱
                      targetFindData.title = inputTitle;

                      this.props.updateMultipleFindData(newtmpMultipleFindData);
                    }}
                  >
                    Save
                  </LinkButton>

                  <LinkButton onClick={() => this.setShowFindForm(false)}>
                    Cancel
                  </LinkButton>
                </div>
              </form>
            )}

            <hr />
            <LinkButton onClick={() => this.setShowCreate(false)}>
              Replace
            </LinkButton>
            <div className='form-check'>
              <input
                className='form-check-input'
                type='checkbox'
                value=''
                id='defaultCheck1'
              />
              <label className='form-check-label' htmlFor='defaultCheck1'>
                Case Sensitive
              </label>
            </div>
            <LinkButton onClick={() => this.setShowCreate(false)}>
              Back to List
            </LinkButton>

            <hr />
            <div className='my-3 float-right'>
              <LinkButton
                style={{ width: 80 }}
                onClick={() => this.closeDialog(true)}
              >
                Close
              </LinkButton>
            </div>
          </Dialog>
        );
      }
    }

    return mainContent;
  }
}

MultipleFindView.propTypes = {
  errors: PropTypes.object.isRequired,
  project: PropTypes.object.isRequired,
  setIsShowFindAllViewInput: PropTypes.func.isRequired,
  multipleFind: PropTypes.func.isRequired,
  findOperation: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  project: state.project,
  errors: state.errors,
  transOperation: state.transOperation,
  findOperation: state.findOperation,
});

export default connect(mapStateToProps, {
  setStatusValue,
  setIsShowFindAllViewInput,
  setIsShowFindAllViewList,
  setIsShowFindAllViewReplace,
  showHideMultipleView,
  getMultipleFindData,
  removeMultipleFindItem,
  duplicateMultipleFindItem,
  setCreateMutileData,
  updateMultipleFindData,
})(withRouter(MultipleFindView));



// WEBPACK FOOTER //
// ./src/components/multipleFind/MultipleFindView.js